import { LOGIN, SET_PERMISSION_PENDING, ENABLE_DARK_SIDE } from './mutation-types'

export default {
  [LOGIN]: (state, user) => {
    state.user = user
  },

  [SET_PERMISSION_PENDING]: (state, value) => {
    state.permissionPending = value
  },

  [ENABLE_DARK_SIDE]: state => {
    state.dark = true
  },
}
